<template>
    <div data-app>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
        <v-data-table
            :headers="billingHeaders"
            :items="items"
            :search="search"
            item-key="id"
            :items-per-page="10"
            class="elevation-0 billing_table"
            :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'first_page',
                lastIcon: 'last_page',
                prevIcon: 'skip_previous',
                nextIcon: 'skip_next',
            }"
            :loading="loading.billings_list"
            loading-text="Loading... Please wait"
        >
            <template v-slot:item.name="{ item }">
                {{ item.name | name }}
            </template>
            <template v-slot:item.bill_in_bulk="{ item }">
                {{ item.bill_in_bulk ? 'Yes' : 'No' }}
            </template>
            <template v-slot:item.actions="{ item }">
                <span>
                    <loading-icon-button
                        @click="viewBilling(item)"
                        tooltip="Edit Billing"
                        :loading="loading.edit_billing_id == item.id"
                    >
                        edit
                    </loading-icon-button>
                    <loading-icon-button
                        @click="deleteBilling(item)"
                        tooltip="Delete Billing"
                        :loading="loading.remove_billing_id == item.id"
                    >
                        clear
                    </loading-icon-button>
                </span>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";

export default {
    components: {
        LoadingIconButton,
        DataTable,
    },
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            search: "",
            billingHeaders: [
                {
                    text: "Billing ID",
                    align: "center",
                    sortable: true,
                    value: "id",
                },
                {
                    text: "Billing Name",
                    align: "center",
                    value: "name"
                },
                {
                    text: "Rcti Description",
                    align: "center",
                    value: "rcti_description"
                },
                {
                    text: "Billing Type",
                    align: "center",
                    value: "type"
                },
                {
                    text: "Account Code",
                    align: "center",
                    value: "account_code",
                },
                {
                    text: "Rate",
                    align: "center",
                     value: "rate"
                },
                {
                    text: "Bill In Bulk",
                    align: "center",
                    value: "bill_in_bulk"
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
        };
    },
    methods: {
        viewBilling(billing) {
            this.$emit("edit-billing", billing);
        },
        deleteBilling(billing) {
            this.$emit("delete-billing", billing);
        },
        ...filters,
    },
    filters: {
        ...filters,
    },
};
</script>
<style scoped lang="scss">
.billing_table {
    table {
        td {
            text-align: center;
        }
    }

    .v-data-footer__select {
        display: none;
    }
}
</style>
